module.exports = __webpack_public_path__ + "img/project.f390ed5c.svg";